 
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import Landingpage from './components/landingpage/Landingpage';
import Boarding from "./components/Boarding/Boarding"
import Daycare from './components/daycare/dayCare';
 
import AboutUs from './components/AboutUs/AboutUs';
import Contactus from './components/ContactUS/Contactus';

function App() {
  return (
    <Router >
    <Routes>
                 <Route path="/" element={<Landingpage/>} />
                 <Route path="/daycare" element={<Daycare />} />
              <Route path="/boarding" element={<Boarding/>} />
              <Route path="/aboutus" element={<AboutUs/>} />
              <Route path="/contactus" element={<Contactus/>} />
                 </Routes>
        </Router>
        
       
  );
}

export default App;
